import React, { useEffect, useState } from "react";
import { Box, Button, Heading, Spinner, Text } from "@chakra-ui/react";
import { Link, useSearchParams } from "react-router-dom";
import { secureFetch } from "../data/secureFetch";
import { setDonorToken } from "../data/donorAuth";

function DonorVerifyEmail() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const verify = async () => {
      const token = searchParams.get("token");
      if (!token) {
        setError("Verification token is missing.");
        setLoading(false);
        return;
      }

      try {
        const response = await secureFetch(
          `/api/donor-auth/verify-email?token=${encodeURIComponent(token)}`,
          { includeFirebaseAuth: false },
        );
        if (!response.ok) {
          throw new Error(response.message || "Verification failed");
        }
        if (response.token) {
          setDonorToken(response.token);
        }
        setSuccessMessage(response.message || "Email verified successfully.");
      } catch (err) {
        setError(err.message || "Verification failed");
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [searchParams]);

  return (
    <Box p={6} maxW="md" mx="auto" textAlign="center">
      <Heading size="md" mb={4}>
        Donor Email Verification
      </Heading>
      {loading ? (
        <Spinner size="lg" color="orange.400" />
      ) : error ? (
        <>
          <Text color="red.500" mb={4}>
            {error}
          </Text>
          <Button as={Link} to="/donor/account" colorScheme="orange">
            Go to Donor Account
          </Button>
        </>
      ) : (
        <>
          <Text color="green.600" mb={4}>
            {successMessage}
          </Text>
          <Button as={Link} to="/donor/account" colorScheme="orange">
            Continue to Donor Account
          </Button>
        </>
      )}
    </Box>
  );
}

export default DonorVerifyEmail;
